module.exports = __webpack_public_path__ + "r-v3/img/new_window.46f58596.svg";